import useSWR from 'swr';
import axiosInstance from '@api/axios.ts';

interface OverallCreditUsage {
  total_credits_consumed: number;
  total_users: number;
  average_credits_per_user: number;
  subscription_limit_reached: number;
  fallback_usage: number;
  case_credits_consumed: number;
  demand_letter_credits_consumed: number;
  deposition_credits_consumed: number;
}

const fetcher = async (): Promise<OverallCreditUsage> => {
  try {
    const res = await axiosInstance({
      method: 'GET',
      url: '/api/admin/credit-usage/overall/',
    });
    return res.data;
  } catch (error: any) {
    console.warn('Overall credit usage endpoint not yet implemented:', error);
    return {
      total_credits_consumed: 0,
      total_users: 0,
      average_credits_per_user: 0,
      subscription_limit_reached: 0,
      fallback_usage: 0,
      case_credits_consumed: 0,
      demand_letter_credits_consumed: 0,
      deposition_credits_consumed: 0,
    };
  }
};

const useOverallCreditUsage = () => {
  const { data, isLoading } = useSWR<OverallCreditUsage>(
    '/api/admin/credit-usage/overall/',
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
    }
  );

  return {
    data,
    isLoading,
  };
};

export default useOverallCreditUsage;
